import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { createTheme } from ".";

import type { ThemeConfig } from ".";
import type { ThemeProviderProps } from "@emotion/react";
import type { ReactElement, ReactNode } from "react";

interface Props {
  mode: ThemeConfig["mode"];
  children: ReactNode;
}
export const ThemeProvider = ({ children, mode }: Props): ReactElement<ThemeProviderProps> => (
  <MuiThemeProvider theme={createTheme({ mode })}>{children}</MuiThemeProvider>
);
